import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormFieldConfig } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';

import { AssignmentStatusAllItems } from '../../../../meta-data/app-meta-data.service';

interface AssignmentStatusDisplay {
  readonly display: string;
  readonly tone: 'active' | 'completed' | 'cancelled' | 'deleted' | 'unknown';
}

@DwComponent({
  key: 'assignment-status-form-control',
  name: 'Assignment Status Form Control',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-assignment-status-form-control',
  templateUrl: './assignment-status-form-control.component.html',
  styleUrls: ['./assignment-status-form-control.component.scss']
})
export class AssignmentStatusFormControlComponent implements DwFormControl, OnInit, OnDestroy {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  inputClass = 'form-control';
  @Input() context: DwContext;

  statusDisplay: AssignmentStatusDisplay = this.getStatusDisplay(null);
  showButton = false;
  showChip = false;

  private valueChangesSubscription: Subscription;

  ngOnInit(): void {
    this.updateConfig();
    this.updateStatus(this.control?.value);

    this.valueChangesSubscription = this.control?.valueChanges.subscribe(value => {
      this.updateStatus(value);
    });
  }

  ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  get control(): AbstractControl {
    return this.formGroup?.get(this.fieldDef?.attrName);
  }

  private updateStatus(value: any): void {
    this.statusDisplay = this.getStatusDisplay(value);
  }

  private updateConfig(): void {
    const config = this.resolveConfig();

    this.showButton = this.resolveBoolean(config?.showButton, false);
    this.showChip = this.resolveBoolean(config?.showChip ?? config?.showInChip, false);
  }

  private getStatusDisplay(value: any): AssignmentStatusDisplay {
    const statusId = Number(value);

    switch (statusId) {
      case AssignmentStatusAllItems.Active:
        return { display: 'Active', tone: 'active' };
      case AssignmentStatusAllItems.Completed:
        return { display: 'Completed', tone: 'completed' };
      case AssignmentStatusAllItems.Cancelled:
        return { display: 'Cancelled', tone: 'cancelled' };
      case AssignmentStatusAllItems.Deleted:
        return { display: 'Deleted', tone: 'deleted' };
      default:
        return { display: 'Unknown', tone: 'unknown' };
    }
  }

  private resolveConfig(): any {
    const fieldDefAny = this.fieldDef as any;

    return fieldDefAny?.config || fieldDefAny?.componentConfig || fieldDefAny?.configData || {};
  }

  private resolveBoolean(value: any, defaultValue: boolean): boolean {
    if (value === undefined || value === null || value === '') {
      return defaultValue;
    }

    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }

    return !!value;
  }
}
